import { object, string } from 'yup';

import getValidationTexts from 'common/utils/getValidationTexts';
import { emailRegex } from 'common/utils/helpers';

export default () => {
    const { REQUIRED_TEXT, EMAIL_VALIDATION_TEXT, MINIMUM_NUMBER_CHARACTERS } =
        getValidationTexts();

    return object().shape({
        email: string()
            .required(REQUIRED_TEXT)
            .matches(emailRegex, EMAIL_VALIDATION_TEXT)
            .nullable(),
        password: string()
            .required(REQUIRED_TEXT)
            .min(8, MINIMUM_NUMBER_CHARACTERS)
            .nullable(),
    });
};
